<template>
  <div class="score-box">
    <div class="star-box">
      <div class="box star_gray">
        <img
          class="star"
          v-for="x in 5"
          :key="x"
          src="./imgs/star_gray.png"
          alt=""
        />
      </div>
      <div class="box star_red" :style="scoreStyle">
        <img
          class="star"
          v-for="y in 5"
          :key="y"
          src="./imgs/star_red.png"
          alt=""
        />
      </div>
    </div>

    <span class="score-txt">{{ score | toFixedOne }}</span>
  </div>
</template>
<script>
export default {
  props: {
    score: {
      type: String,
      default: "0"
    }
  },
  data() {
    return {
      scoreStyle: "",
    };
  },
  filters: {
    toFixedOne(val) {
      return Number(val).toFixed(1);
    }
  },
  mounted() {
    this.$nextTick(() => {
      // console.log('width',document.getElementsByClassName("star")[0].offsetWidth);
      let starWidth = document.getElementsByClassName("star")[0].offsetWidth;
      let widthRate = parseInt(Number(this.score).toFixed(1) / 5 * 100) 
      let scorewidth = widthRate >= 100 ? '100%' : widthRate + "%";
      console.log('widthRate',widthRate,scorewidth)
      this.scoreStyle = { width: scorewidth };
    });
  }
};
</script>
<style lang="stylus" scoped>
.score-box {
    position: relative;
    display: flex;
    width: 100%;
    height: 21px;
    flex: 1;
    .star-box {
        position: relative;
        width: 105px;
        height: 21px;
        display: inline-block;
        top: -1px;
    }
    .box {
        display: flex;
        position: absolute;
        top: 0;
        left: 0;
        overflow: hidden;
        &.star_gray {
          width: 105px;
        }
    }
    .star {
        display: inline-block;
        width: auto;
        height: 21px;
        font-size: 0;
    }
    .score-txt {
        margin-left: 6px;
        height: 20px;
        font-size: 15px;
        font-family: SanFranciscoText-Heavy, SanFranciscoText;
        font-weight: 800;
        color: #FC2040;
        line-height: 20px;
    }
}
</style>
